import { AutogenLayoutPayee401kRatesList } from "./autogen/AutogenLayoutPayee401kRatesList";
import {
    ClickEvent, CrudDecorator, CrudDecoratorCloseEvent, DataSourceExecutionEvent, DataSourceMode, Layout,
    LookupModelSearchEvent, TableContentsChangedEvent, TableRow, TableRowDisplayEvent, Textbox
} from "@mcleod/components";
import { UrlUtil } from "@mcleod/core";
import { Payee401kRates } from "./Payee401kRates";

export class Payee401kRatesList extends AutogenLayoutPayee401kRatesList {
    onLoad(): void | Promise<void> {
        this.searchpanel401kRates.expand();
        this.textboxPayee.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter["drs_payee.type_of"] = "C";
            event.filter["non_office_emp"] = "Y";
        });
        this.textboxPayee401kRatedeductCodeIdSearch.addBeforeLookupModelSearchListener((event: LookupModelSearchEvent) => {
            event.filter["code_type"] = "in D,B";
        });
        this.tablePayee401kRateList.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const textboxTotalPayeePercent = tableRow.findComponentById("textboxTotalPayeePercent") as Textbox;
            const textboxTotalPayeeAmount = tableRow.findComponentById("textboxTotalPayeeAmount") as Textbox;
            const textboxTotalEmployerPercent = tableRow.findComponentById("textboxTotalEmployerPercent") as Textbox;
            const textboxTotalEmployerAmount = tableRow.findComponentById("textboxTotalEmployerAmount") as Textbox;
            if (textboxTotalPayeePercent && textboxTotalPayeeAmount && textboxTotalEmployerPercent && textboxTotalEmployerAmount) {
                const isFlat = tableRow.data.get("payee_401k_rate.calculation_method") === "F";
                const isPercent = tableRow.data.get("payee_401k_rate.calculation_method") === "P";
                textboxTotalEmployerAmount.visible = isFlat;
                textboxTotalEmployerPercent.visible = isPercent;
                textboxTotalPayeeAmount.visible = isFlat;
                textboxTotalPayeePercent.visible = isPercent;
            }
        });
        this.tablePayee401kRateList.addContentsChangedListener((event: TableContentsChangedEvent) => {
            this.sourcePayee401kRateList.search(this.sourcePayee401kRateList.lastSearch);
        });
    }

    rateRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        const layout = Layout.getLayout(this.tablePayee401kRateList.detailLayout) as Payee401kRates;
        const key = tableRow.data.get("id");
        const urlParam = { mode: "update", key: key };
        const url = "/" + this.tablePayee401kRateList.detailLayout + UrlUtil.buildQueryString(urlParam);
        const crudPanel = new CrudDecorator({
            layout: layout,
            mode: DataSourceMode.UPDATE,
            dataSource: layout.mainDataSource,
            key: key,
            pseudoNavigateUrl: url,
            layoutLoadListeners: () => {
                layout.sourcePayee401kRate.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
                    layout.selectRateRecordById(tableRow.data.get("payee_401k_rate.unique_id"));
                });
            },
            headerProps: {
                showClose: true,
                showSaveAndClose: true,
                showDelete: true,
                doAfterClose: (event: CrudDecoratorCloseEvent) => {
                    if (event.userDeleted()) {
                        this.sourcePayee401kRateList.search(this.sourcePayee401kRateList.lastSearch);
                    }
                },
                onExecute: () => {
                    this.sourcePayee401kRateList.search(this.sourcePayee401kRateList.lastSearch);
                }
            }
        });
        crudPanel.slideIn({ speed: 200 });
    }
}
